import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { DataService } from '../services/data.service';
import { VenueType } from '../shared/enums';

// A read-only venue is a menu to browse, not order from - so the cart page (reachable by URL,
// or via a cart left over from before the venue became read-only) sends guests back to the menu.
// Waits for the restaurant like the other entry guards, since this can run before boot finishes.
export const orderingEnabledGuard: CanActivateFn = () => {
  const dataService = inject(DataService);
  const router = inject(Router);

  return toObservable(dataService.restaurant).pipe(
    filter(restaurant => restaurant !== null),
    take(1),
    map(restaurant => restaurant.type === VenueType.ReadOnly ? router.createUrlTree(['/menu-home']) : true),
  );
};
